import { parseWidgetChart } from "../widgets/charts/widgetChart";
import { parseWidgetMap } from "../widgets/maps/widgetMap";
import { rowsFrom, label, display } from "../widgets/reportData";

export interface ExportInput {
	title: string;
	widgetName: string;
	configJson: string | null;
	data: unknown;
}
export function exportModel(input: ExportInput) {
	const rows = rowsFrom(input.data);
	const map = parseWidgetMap(input.widgetName, rows);
	const chart = parseWidgetChart(input.widgetName, rows, input.configJson);
	const columns = [...new Set(rows.flatMap((row) => Object.keys(row)))];
	// Heatmaps were SVG exports in MVC; retain downloadable PNG rather than dropping that format.
	const kind =
		!rows.length || (map && !map.markers.length)
			? "empty"
			: map
				? "image"
				: chart
					? chart.kind === "heatmap"
						? "image"
						: "chart"
					: "grid";
	return {
		kind,
		// The export is a fixed-width screenshot, so render every category instead of a scrolling window.
		chart: chart && chart.kind !== "heatmap" ? { ...chart, categoryWindow: undefined } : chart,
		map,
		headers: columns.map(label),
		cells: rows.map((row) => columns.map((key) => row[key] ?? null)),
		displayCells: rows.map((row) => columns.map((key) => display(row[key]))),
	};
}
